import styled from 'styled-components';
import { PaginationMixin } from '../../mixins/components/PaginationMixin';
export var StyledPagination = /*#__PURE__*/styled.nav.withConfig({
  displayName: "StyledPagination",
  componentId: "c11n-8-107-0__sc-4uav85-0"
})(["", ""], PaginationMixin);